export default function Footer() {
  return (
    <footer style={{
      padding: "40px 0"
    }}>
      <div style={{
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "0 60px",
        fontSize: "14px",
        color: "#9ca3af"
      }}>
        <div style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "start",
          justifyContent: "space-between",
          gap: "24px",
          flexWrap: "wrap"
        }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <img 
                src="/neon-crow-logo.png" 
                alt="Neon Crow Games"
                style={{
                  width: "32px",
                  height: "32px",
                  filter: "drop-shadow(0 0 6px rgba(6, 182, 212, 0.6))"
                }}
              />
              <span style={{ fontWeight: "bold", color: "#ffffff" }}>Neon Crow Games</span>
            </div>
            <p style={{ fontSize: "12px", margin: "4px 0 0 0" }}>© {new Date().getFullYear()} Neon Crow Games. All rights reserved.</p>
            <p style={{ fontSize: "12px", color: "#6b7280", margin: "0" }}>Strange worlds. Sharper minds.</p>
          </div>
          <div style={{ display: "flex", gap: "24px" }}>
            <a 
              href="https://neoncrowgames.com/#/privacy"
              style={{ color: "#9ca3af", textDecoration: "none", transition: "color 0.3s" }}
              onMouseEnter={(e) => e.currentTarget.style.color = "#d1d5db"}
              onMouseLeave={(e) => e.currentTarget.style.color = "#9ca3af"}
            >
              Privacy
            </a>
            <a 
              href="mailto:info@neoncrowgames.com" 
              style={{ color: "#9ca3af", textDecoration: "none", transition: "color 0.3s" }}
              onMouseEnter={(e) => e.currentTarget.style.color = "#d1d5db"}
              onMouseLeave={(e) => e.currentTarget.style.color = "#9ca3af"}
            >
              info@neoncrowgames.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
